
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const WTPPreventiveRecirculationWorkExportData = (props) => {
    const { ExcelData, name, WardName, FromDate } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: 'auto' }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4>

                <tr><td></td></tr>

                <tr>
                    <td style={{ textAlign: "center", fontSize: 16, fontWeight: 'bold' }} colSpan={2}>From Date: {moment(FromDate).format('DD-MM-YYYY')}</td>
                    <td></td>
                    <td style={{ textAlign: "center", fontSize: 16, fontWeight: 'bold' }} colSpan={2}>Ward Name: {WardName}</td>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                        <th className="sr_no_col px-3" style={{ width: "8vw" }}>Sr No.</th>
                        <th className="px-3">Date</th>
                        <th className="px-3">Pump</th>
                        <th className="px-3">Start Time</th>
                        <th className="px-3">Stop Time</th>
                        <th className="px-3">Sump Start level (Mtr.)</th>
                        <th className="px-3">Sump Stop level (Mtr.)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((i) => {
                            return (
                                <tr>
                                    <td style={{ textAlign: "center" }}>{i?.rowNum}</td>
                                    <td>{i?.pumpStartDate ? moment(i?.pumpStartDate).format('DD-MM-YYYY') : '-'}</td>
                                    <td>{i?.pumpNumber ? i?.pumpNumber : '-'}</td>
                                    <td>{i?.pumpStartTime ? i?.pumpStartTime : '-'}</td>
                                    <td>{i?.pumpStopTime ? i?.pumpStopTime : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{i?.startSumpLevel ? i?.startSumpLevel : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{i?.stopSumpLevel ? i?.stopSumpLevel : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}